import React from 'react';
import { itemFilterTypes } from '../../../constants';
import FilterGroup from './filter-group';

const BusinessLibraryFilterGroup = ({ onApply }) => {
  const activeFilters = [
    itemFilterTypes.cpdCategory,
    itemFilterTypes.status,
    itemFilterTypes.publisherGoal,
  ]

  return <div id='business-library-filter-group'>
    <FilterGroup {...{
      activeFilters,
      onApply
    }} />
  </div>
}

export default BusinessLibraryFilterGroup


// WEBPACK FOOTER //
// ./src/containers/components/filters/business-library-filter-group.js